import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { isChinaUser } from '../utils/ChinaUtil';
import { gcApi } from 'config/axios';

import {
    REQUEST_SEGMENT_LEADERBOARD_ONLY_ME,
    RECEIVE_SEGMENT_LEADERBOARD_ONLY_ME,
    REQUEST_SEGMENT_LEADERBOARD_ONLY_ME_FAIL,
    REQUEST_ACTIVITY_POLYLINE_FOR_SEGMENT,
    REQUEST_SEGMENT_LEADERBOARD,
    DELETE_SEGMENT,
    REQUEST_FAVORITE_GROUP_SEGMENT,
    DELETE_FAVORITE_GROUP_SEGMENT,
    UPDATE_FAVORITE_GROUP_SEGMENT,
    REQUEST_SEGMENT_DETAILS,
    REQUEST_SEGMENTS,
    ADD_SEGMENT_TO_FAVOURITES,
    REMOVE_SEGMENT_FROM_FAVOURITES
} from '../actions/ActionTypes';

import {
    receiveActivityPolylineForSegment,
    requestActivityPolylineForSegmentFail,
    receiveSegmentLeaderBoard,
    deletedSegment,
    receiveFavoriteGroupActivities,
    receiveSegmentDetails,
    segmentDetailsError,
    receiveSegments,
    toggleSegmentFavorite,
    setSegmentFavoriteStatusInSegmentDetails
} from 'actions/segmentActions';
import { fetchMultipleUserSocialProfileImage } from 'actions/userSocialProfileImageActions';

// worker
export function* fetchSegementLeaderboardOnlyMe(action) {
    const { segmentId, displayName } = action;

    try {
        const response = yield call(gcApi.get, `/segment-service/leaderboard/segment/${segmentId}/rank/${displayName}`);

        yield put({
            type: RECEIVE_SEGMENT_LEADERBOARD_ONLY_ME,
            data: { ...response.data, uuid: segmentId },
            receivedAt: Date.now()
        });
    } catch (e) {
        yield put({
            type: REQUEST_SEGMENT_LEADERBOARD_ONLY_ME_FAIL,
            data: {}
        });
    }
}

export function* fetchActivityPolylineForSegment({ activityId }) {
    try {
        const response = yield gcApi.get(`/segment-service/segment/activity/${activityId}`);

        yield put(receiveActivityPolylineForSegment(response.data, activityId));
    } catch (error) {
        yield put(requestActivityPolylineForSegmentFail(error.response));
    }
}

export function* fetchSegmentLeaderBoard({ data, isEndlessLoading }) {
    try {
        const response = yield gcApi.post(`/segment-service/leaderboard/search/`, data);

        yield put(receiveSegmentLeaderBoard(response.data, isEndlessLoading));

        yield fork(fetchSegmentLeaderBoardProfileImageAndFrame, response.data);
    } catch (error) {}
}

export function* deleteSegment({ segmentUuid, callback: { onSuccess } }) {
    try {
        const response = yield gcApi.delete(`segment-service/segment/${segmentUuid}`);

        yield put(deletedSegment(response, segmentUuid));

        if (onSuccess) {
            yield call(onSuccess(response.data));
        }
    } catch (error) {}
}

export function* getFavoriteGroupActivities({ administeredGroupId, segmentPk }) {
    try {
        const response = yield gcApi.get(`segment-service/segment/group/${administeredGroupId}/segment/${segmentPk}`);

        yield put(receiveFavoriteGroupActivities(response.data));
    } catch (error) {}
}

export function* deleteFavoriteGroupActivities({ item }) {
    try {
        const response = yield gcApi.delete(`segment-service/segment/group/${item.groupPk}/segment/${item.segmentPk}`);

        yield put(receiveFavoriteGroupActivities(response.data));
    } catch (error) {}
}

export function* putFavoriteGroupActivities({ item }) {
    try {
        const response = yield gcApi.put(
            `segment-service/segment/group/${item.groupPk}/segment/${item.segmentPk}`,
            item
        );

        yield put(receiveFavoriteGroupActivities(response.data));
    } catch (error) {}
}

export function* fetchSegmentDetails({ segmentId, callback }) {
    let params = {
        targetCoordinateSystem: isChinaUser() ? 'BD09' : null
    };

    try {
        const response = yield gcApi.get(`/segment-service/segment/${segmentId}`, { params });
        yield put(receiveSegmentDetails(response.data, segmentId));

        yield call(handlingCallback, callback, response);
    } catch (error) {
        yield put(segmentDetailsError(error));
    }
}

export function* fetchNearBySegments({ filters = {}, callback }) {
    filters.limit = filters.limit || 200;
    filters.showFavorites = true; // The API requires the flag or it returns wrong value for favorite.

    if (isChinaUser()) {
        filters.coordinateSystem = 'BD09';
    }

    try {
        const response = yield gcApi.post(`segment-service/segment/filterSegments`, filters);
        yield put(receiveSegments(response.data));

        yield call(handlingCallback, callback, response);
    } catch (error) {
        yield put(segmentDetailsError(error));
    }
}

export function* addSegmentToFavourites({ segment }) {
    try {
        const response = yield gcApi.put(`/segment-service/segment/user/${segment.segmentPk}`);

        yield put(toggleSegmentFavorite(segment.segmentPk, response.data.favorite));
        yield put(setSegmentFavoriteStatusInSegmentDetails(response.data.favorite));
    } catch (error) {}
}

export function* removeSegmentFromFavourites({ segment }) {
    try {
        const response = yield gcApi.delete(`/segment-service/segment/user/${segment.segmentPk}`);

        yield put(toggleSegmentFavorite(segment.segmentPk, response.data.favorite));
        yield put(setSegmentFavoriteStatusInSegmentDetails(response.data.favorite));
    } catch (error) {}
}

function handlingCallback(callback, response) {
    if (callback && callback.onSuccess) {
        callback.onSuccess(response.data);
    }
}

/// section: fetching profile image and frame

/**
 * handle fetch leaderboard response.
 * @param {Object} responseData
 * @param {number} responseData.leaderUserProfilePk
 * @param {number} responseData.secondPlaceUserProfilePk
 * @param {number} responseData.thirdPlaceUserProfilePk
 * @param {number} responseData.lastUserProfilePk
 * @param {Object[]} responseData.leaderboardRowDTOList
 * @param {number} responseData.leaderboardRowDTOList[].userProfilePk
 */
function* fetchSegmentLeaderBoardProfileImageAndFrame(responseData) {
    if (!responseData) {
        return;
    }
    const userIds = [];
    userIds.push(responseData.leaderUserProfilePk);
    userIds.push(responseData.secondPlaceUserProfilePk);
    userIds.push(responseData.thirdPlaceUserProfilePk);
    userIds.push(responseData.lastUserProfilePk);
    if (Array.isArray(responseData.leaderboardRowDTOList) && responseData.leaderboardRowDTOList.length > 0) {
        responseData.leaderboardRowDTOList.forEach((item) => {
            userIds.push(item.userProfilePk);
        });
    }
    yield fork(fetchProfileImageAndFrameSaga, userIds);
}

function* fetchProfileImageAndFrameSaga(userIds) {
    if (!userIds || !userIds.length) {
        return;
    }
    yield put(fetchMultipleUserSocialProfileImage(userIds));
}

/// end section: fetching profile image and frame

// watcher
export const segmentSagas = [
    takeEvery(REQUEST_SEGMENT_LEADERBOARD_ONLY_ME, fetchSegementLeaderboardOnlyMe),
    takeEvery(REQUEST_ACTIVITY_POLYLINE_FOR_SEGMENT, fetchActivityPolylineForSegment),
    takeEvery(REQUEST_SEGMENT_LEADERBOARD, fetchSegmentLeaderBoard),
    takeEvery(DELETE_SEGMENT, deleteSegment),
    takeEvery(REQUEST_FAVORITE_GROUP_SEGMENT, getFavoriteGroupActivities),
    takeEvery(DELETE_FAVORITE_GROUP_SEGMENT, deleteFavoriteGroupActivities),
    takeEvery(UPDATE_FAVORITE_GROUP_SEGMENT, putFavoriteGroupActivities),
    takeEvery(REQUEST_SEGMENT_DETAILS, fetchSegmentDetails),
    takeEvery(REQUEST_SEGMENTS, fetchNearBySegments),
    takeEvery(ADD_SEGMENT_TO_FAVOURITES, addSegmentToFavourites),
    takeEvery(REMOVE_SEGMENT_FROM_FAVOURITES, removeSegmentFromFavourites)
];
